/**
 * Centralized, user-facing product display names.
 *
 * Single source of truth for product branding shown to users. When a product is
 * rebranded, update the value here and every user-facing surface follows.
 *
 * Only user-facing DISPLAY strings belong here. Code symbols, CSS classes, route
 * paths, and API contract values (e.g. application category values like
 * "IcaPipeline") are intentionally NOT covered by this file.
 */
export const ProductNames = {
    /**
     * Formerly known as "ICA" / "Illumina Connected Analytics".
     * Rebranded to "Illumina BioInsight Platform Core" (BASE-89172 / SWIFT-6329),
     * but per branding guidance it is displayed to users simply as "Core"
     * everywhere — there is no long/short distinction.
     * Internal teams will likely keep calling it ICA for a while, so this note is
     * here to make clear that all of these names refer to the same product.
     */
    IlluminaBioInsightPlatformCore: 'Core',
} as const;
